import React from 'react';
import noFoundSrc from './notFound.svg';
import styles from './PageNotFound.module.scss';
import { useNavigate } from 'react-router-dom';
import Button from 'component/atom/forms/button/Button';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className={styles['page-container']}>
      <img src={noFoundSrc} alt="" />
      <Button
        onClick={() => navigate('/')}
        label="Back Home"
        variant="danger"
      />
    </div>
  );
};

export default PageNotFound;
